import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { Config } from 'domains/ContentStores/ManagedStores/ManagedStore'
import { Structure } from 'pages/NWPlatform/ContentStores/ManagedStores/ManagedStore/Structure'
import { managedStoresRoute } from 'pages/NWPlatform/ContentStores/ManagedStores/Routing'

export const managedStoreRoute = createRoute({
  getParentRoute: () => managedStoresRoute,
  path: DynamicRouteParameterWPrefix.MANAGED_STORE_ID,
  loader: () => ({
    crumb: t('entity:content.managedStore', { count: 1 }),
  }),
})

export const managedStoreLayoutRoute = createRoute({
  getParentRoute: () => managedStoreRoute,
  id: 'managedStoreLayout',
  component: Structure,
})

export const managedStoreConfigRoute = createRoute({
  getParentRoute: () => managedStoreLayoutRoute,
  path: '/',
  component: Config,
})
